import api from '@utils/api'
import { API_ENDPOINTS } from '@utils/api-endpoints'

export const getGeoNamesbyLatLng = async (lat: number, lon: number) => {
  try {
    // retrieve data with fetch
    if (Number(lat) && Number(lon)) {
      const { data } = await api.get(API_ENDPOINTS.GEONAMES_NEARBY(lat, lon))
      if (data.success) {
        return { geoNames: [...data.data.geoNames] }
      } else {
        return data
      }
    } else {
      const data = {
        data: null,
        msg: 'Invalid lat/lon',
        success: false,
      }
      return { geoNames: { ...data } }
    }
  } catch (error: any) {
    const data = {
      data: null,
      msg: error?.message,
      success: false,
    }
    return { geoNames: { ...data } }
  }
}
